import { ArrowUpRight, Calendar, Sparkles } from "lucide-react";
import { SITE } from "@/lib/site";

export default function Book() {
  return (
    <div data-testid="page-book" className="pt-32 pb-24">
      <div className="mx-auto max-w-[1400px] px-6 sm:px-10">
        <div className="grid gap-10 lg:grid-cols-12 items-end mb-10">
          <div className="lg:col-span-8">
            <div className="overline">Booking</div>
            <h1 className="font-display text-5xl sm:text-7xl mt-4 tracking-tight text-balance">
              Reserve your <span className="italic font-light">chair.</span>
            </h1>
            <p className="mt-6 max-w-xl text-[hsl(var(--onyx)/0.65)]">
              Choose your service and stylist below. New extension and hair-loss
              clients begin with a complimentary consultation.
            </p>
          </div>
          <div className="lg:col-span-4 lg:text-right">
            <a
              href={SITE.bookingUrl}
              target="_blank"
              rel="noreferrer"
              data-testid="book-external-cta"
              className="btn-pill btn-primary"
            >
              Open full booking <ArrowUpRight size={16} />
            </a>
          </div>
        </div>

        <div className="rounded-[2rem] overflow-hidden border border-[hsl(var(--onyx)/0.08)] bg-white shadow-[0_20px_80px_-40px_rgba(20,10,15,0.25)]">
          <div className="glass px-6 py-4 flex items-center gap-3 border-b border-white/40">
            <Calendar size={16} className="text-[hsl(var(--gold))]" />
            <span className="text-sm text-[hsl(var(--onyx)/0.7)]">
              Secure booking · Powered by our booking system
            </span>
          </div>
          <div className="relative bg-cream">
            <iframe
              data-testid="booking-iframe"
              title="Book Appointment"
              src={SITE.bookingUrl}
              className="w-full"
              style={{ height: "900px", border: 0 }}
              loading="lazy"
            />
          </div>
        </div>

        <div className="mt-14 grid gap-6 sm:grid-cols-3">
          {[
            {
              t: "Consultation-first",
              d: "New extensions & hair-loss clients begin with a private consult.",
            },
            {
              t: "Booking fee",
              d: "A 50% booking fee secures your appointment — deducted from your total.",
            },
            {
              t: "48h cancellation",
              d: "We require 48 hours notice for cancellations or rescheduling.",
            },
          ].map((c) => (
            <div
              key={c.t}
              className="rounded-3xl bg-white border border-[hsl(var(--onyx)/0.06)] p-7"
            >
              <Sparkles size={18} className="text-[hsl(var(--gold))]" />
              <div className="font-display text-2xl mt-3">{c.t}</div>
              <p className="mt-2 text-sm text-[hsl(var(--onyx)/0.6)] leading-relaxed">
                {c.d}
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
